import styled from "styled-components";

const Input = styled.input`
  width: 100%;
  height: 4rem;
  font-size: 1.6rem;
  border: 0.2rem solid #98a8be;
  margin: 0 0 2.6rem 0;
`;

export default Input;
